import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import Swal from 'sweetalert2'
import router from '../router'

window.Pusher = Pusher

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.VUE_APP_PUSHER_APP_KEY,
    cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
    forceTLS: false,
})
let isOrderAlertActive = false

const channel = window.Echo.channel('admin');

channel.listen('NewOrderReceived', () => {
    const isAlertEnabled = localStorage.getItem('orderAlertEnabled') === 'true';
    if (!isAlertEnabled) {
        console.log('Alert system is OFF - ignoring new order notification');
        return;
    }

    if (isOrderAlertActive) {
        console.log('Order alert already active - ignoring duplicate event')
        return
    }
    isOrderAlertActive = true

    const audio = new Audio('/sounds/warning_sound.mp3');
    audio.loop = true;
    audio.play().catch(err => {
        console.log('Audio playback blocked:', err);
    });

    Swal.fire({
        title: 'New Order Received',
        text: 'You have received a new order!',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'View Orders',
        cancelButtonText: 'Close',
        allowOutsideClick: false,
        allowEscapeKey: false,
    }).then((result) => {
        audio.pause();
        audio.currentTime = 0;
        isOrderAlertActive = false
        if (result.isConfirmed) {
            router.push('/orders');
        }
    });
});